import { Typography, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { useNavigate } from 'react-router-dom';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import { getUserDetails, getUserPermission } from 'state/reducers/user.reducers';
import { pagesEnum } from 'constants/ui.constants';
import CreateMessage from 'components/CreateMessage';
import ColoredArea from 'components/ColoredArea';
import { UserPermission } from 'constants/user.constants';
import { getUserName } from 'utils';

export default function CallToAction() {
	const navigate = useNavigate();
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const prefixField = 'page.dashboard.';
	const { firstName, firstNameHebrew } = useAppSelector(getUserDetails);
	const userPermission = useAppSelector(getUserPermission);
	const selectedLanguage = useAppSelector(selectLanguage);

	return (
		<ColoredArea styleObj={{ background: theme.palette.root.brandSecondary_012 }}>
			<Typography variant="h3">
				{t(`${prefixField}welcome.text`)}, {getUserName(firstName, firstNameHebrew, selectedLanguage)}
			</Typography>
			<CreateMessage
				noAction={[UserPermission.VIEWER, UserPermission.UNPERMITTED, UserPermission.NONE].includes(
					userPermission
				)}
				title={t(`${prefixField}message`)}
				text={t(`${prefixField}description`)}
				imageKey={`${prefixField}no_balance.icon`}
				addLabel={t(`${prefixField}add_balance_button.text`)}
				startIcon={`${prefixField}add_balance_button.icon`}
				onclick={() => {
					navigate(`/${pagesEnum.BALANCE}`);
				}}
			/>
		</ColoredArea>
	);
}
